import { ActionType, action, createStandardAction } from "typesafe-actions";
import { ResponseModel } from "./reducer";

const actions = {
    throwError: createStandardAction('[error] THROW_ERROR').map(
        ({ body, bodyUsed, headers, ok, redirected, status, statusText, type, url }: { body: any, bodyUsed: any, headers: any, ok: boolean, redirected: boolean, status: number, statusText: string, type: string, url: string }, text: string) => ({
          payload: { body, bodyUsed, headers, ok, redirected, status, statusText, type, url, message: text } as ResponseModel,
        })
    ),
    clearError: createStandardAction('[error] CLEAR_ERROR')<void>()
}

export type ErrorAction = ActionType<typeof actions>

export default actions
